import type { ParticipantBehaviourRecording } from '@piccolohealth/pbs-common';
import { ChakraV3, DescriptionList } from '@piccolohealth/ui';
import { Duration } from '@piccolohealth/util';
import React from 'react';

interface Props {
  recording: ParticipantBehaviourRecording;
}

export const ParticipantBehaviourRecordingValue = (props: Props) => {
  switch (props.recording.__typename) {
    case 'ParticipantBehaviourRecordingFrequency':
      return <>{props.recording.value} times</>;
    case 'ParticipantBehaviourRecordingDuration': {
      if (props.recording.value === 0) {
        return <>0 seconds</>;
      }

      const value = Duration.fromObject({
        seconds: props.recording.value,
      }).rescale();

      return <>{value.toHuman()}</>;
    }
    case 'ParticipantBehaviourRecordingEpisodicSeverity':
      return <>Level {props.recording.value}</>;
    case 'ParticipantBehaviourRecordingAbc':
      return (
        <DescriptionList
          rowGap={0}
          items={[
            {
              title: 'A',
              content: <ChakraV3.Text>{props.recording.antecedent}</ChakraV3.Text>,
            },
            {
              title: 'B',
              content: <ChakraV3.Text>{props.recording.behaviour}</ChakraV3.Text>,
            },
            {
              title: 'C',
              content: <ChakraV3.Text>{props.recording.consequence}</ChakraV3.Text>,
            },
          ]}
        />
      );
    case undefined:
      return <ChakraV3.Text>Unknown</ChakraV3.Text>;
  }
};
